module.exports = __webpack_public_path__ + "static/media/usermanagementhome.84970504.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Help/assets/usermanagementhome.png
// module id = 1856
// module chunks = 193